import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WheelComponent from "../../../../components/WheelComponent";
import { TextView } from "../../../../components";
import UserImage from "../../../../components/UserImage";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import { colors } from "../../../../utils";
import { ASSETS } from "../../../../utils/config";
import ShareIcon from "@mui/icons-material/Share";
export default function WheelCard({
  mainName,
  data,
  onDeleteWheelPress = () => {},
  deletingWheelId,
  isEditable = true,
  handleCloneWheel,
  onShareClick,
}) {
  const nav = useNavigate();

  const [chartState, setChartState] = useState([]);
  useEffect(() => {
    const wheelData = data && data?.wheel_section[0]?.activity_wheel;

    const wheelUpdatedData = wheelData?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      // position: 0,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [data]);

  const onCardPress = (e) => {
    if (data?.id) {
      nav(`/wheelView/${data?.id}`);
    } else {
      console.error("Data ID not available");
    }
  };

  return (
    <>
      <Stack
        style={{
          marginBottom: "3px",
          cursor: "pointer",
          border: "1px solid #E1E1E1",
          borderRadius: "10px",
          margin: "5px",
          width: "40vw",
          height: "28vh",
          position: "relative",
          // backgroundColor: "white",
          backgroundImage: `url(${ASSETS.gradientBgNew})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Stack>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0.5vh",
            }}
          >
            <Stack
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-start"}
            >
              <UserImage size={22} image={data?.user_profile?.profile_image} />
              <TextView
                style={{
                  fontSize: "10px",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#565556",
                  fontWeight: "700",
                  marginLeft: "4px",
                }}
              >
                by {mainName}
              </TextView>
            </Stack>
            <MoreHorizSharpIcon style={{ fontSize: "15px" }} />
          </div> */}
          <Stack style={{ height: "6vh" }}>
            <TextView
              onClick={onCardPress}
              style={{
                fontWeight: "700",
                fontSize: "12px",
                display: "-webkit-box", // Use the webkit box model for the container
                WebkitBoxOrient: "vertical", // Set the box orientation to vertical
                WebkitLineClamp: 2, // Limit the content to 2 lines
                overflow: "hidden", // Hide the overflow content
                textOverflow: "ellipsis", // Add an ellipsis to any overflow text
                margin: "6px",
                color: colors.primary,
                lineHeight: "13px",
              }}
            >
              {data?.wheel_name ?? "-"}
            </TextView>
          </Stack>

          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              padding: -4,
            }}
          >
            <div
              onClick={onCardPress}
              style={{
                paddingTop: "12px",
                // position: "relative",
                // backgroundColor: "#F6F7F9",
                backgroundColor: "white",
                // marginLeft: "-10px",
                // marginRight: "-10px",
                width: "94%",
                borderRadius: "10px",
              }}
            >
              <WheelComponent
                userData={{
                  id: Math.random() * 10,
                  url: data?.wheel_image,
                }}
                maxSelectedArcs={0}
                arcThickness={-10}
                chartData={chartState}
                containerDivStyle={{
                  height: "40vh",
                  width: "36vw",
                  marginTop: "-14vh",
                  marginBottom: "-12vh",
                }}
              ></WheelComponent>
            </div>
          </div>

          <Stack
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ zIndex: 1000 }}
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <ShareIcon
              onClick={(event) => {
                event.stopPropagation();
                onShareClick(data?.id);
              }}
              style={{
                fontSize: "22px",
                marginTop: "7px",
                marginBottom: "7px",
                color: colors.primary,
                zIndex: 1000,
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
